export default __webpack_public_path__ + "static/media/share_orange.3087a2ac.svg";